import React, { Component } from 'react'
import PropTypes from 'prop-types'
import config from '../../config/custom'
import { getModel, getModelName, getAttributeType } from '../../utils/models'
import { request } from '../../utils/http'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'

class Title extends Component {

    constructor(props) {
        super(props)

        this.state = {
            title: ''
        }
    }

    componentWillMount() {
        this.getTitle()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.model !== this.props.model
            || prevProps.value !== this.props.value) {
            this.getTitle()
        }
    }

    async getTitle() {
        const model = getModel(this.props.model)
        let value = this.props.value

        if (_.isInteger(value) || _.isString(value)) {
            const response = await request(`${config.baseUrl}/${this.props.model}/${value}`)
            value = response.data
        }

        if (value) {
            let title = this.getDisplayValue(model, value)

            this.setState({ title })
        }
    }

    getDisplayValue(model, value) {
        if (model.hasOwnProperty('display')) {
            let displayList = _.isArray(model.display) ? model.display : [model.display]

            return _.join(_.map(displayList, i => {
                if (getAttributeType(this.props.model, i) === 'model') {
                    const subModel = getModel(getModelName(this.props.model, i))

                    if (value[i]) {
                        return this.getDisplayValue(subModel, value[i])
                    }
                }
                return value[i]
            }), ' ')
        } else if (value.hasOwnProperty('name')) {
            return value.name
        } else if (value.hasOwnProperty('id')) {
            return <span><FormattedMessage id={`Model.${this.props.model}.title`} /> {value.id}</span>
        }
    }

    render() {
        return <span>{this.state.title}&nbsp;</span>
    }
}

Title.propTypes = {
    model: PropTypes.string.isRequired,
    value: PropTypes.any,
}


export default Title


// WEBPACK FOOTER //
// ./src/containers/Title/index.js